import React, {Fragment, Component} from 'react'
import {Row, Col, Button} from 'reactstrap'
import PropTypes from 'prop-types'
import autobind from 'auto-bind'

import Sidebar from '../common/Sidebar'
import Editor from './Editor/index'
import ModelImporter from './ModelImporter'

import * as API from 'SDK/api'

export default class SchemaManager extends Component {
    propComponents = [
        {
            prop: 'name',
            component: 'GenericWidgetName',
        },
    ]
    showBorder = false
    id = 'SchemaManager'
    requiredOutputs = []
    static propTypes = {
        name: PropTypes.string,
    }
    constructor(props) {
        super(props)
        autobind(this)

        this.state = {
            editingDataModelID: null,
            editingDataModelIsNew: false,
            dataModels: [],
            loading: false,
            kanbanFieldPath: null,
        }
    }

    async syncDataModels() {
        this.setState({loading: true})
        const dataModels = await API.get('data-models', 2)

        this.setState({dataModels, loading: false})
    }

    async addDataModel() {
        this.setState({loading: true})
        let {dataModels} = this.state

        let dataModel = await API.post(
            'data-models',
            {name: 'Some model', description: 'My first description'},
            2
        )
        dataModels.push(dataModel)
        this.setState({
            dataModels,
            editingDataModelID: dataModel._id,
            editingDataModelIsNew: true,
            loading: false,
        })
    }

    async handleDataModelChange(dataModel) {
        const kanbanModel = this.state.dataModels.find(
            (model) => model.name === 'System/Kanban Settings'
        )

        let existing = await API.post(
            `data-models/${kanbanModel._id}/paginate`,
            {
                filter: [
                    {
                        path: 'model_id',
                        type: 'Text',
                        value: [dataModel._id],
                        logic: 'is',
                    },
                ],
                limit: 1,
            },
            2
        )
        if (existing.count) {
            this.setState({
                kanbanFieldPath: existing.result.results[0].status_field_path,
            })
        } else {
            this.setState({kanbanFieldPath: null})
        }
        this.setState({editingDataModelID: null}, () => {
            this.setState({editingDataModelID: dataModel._id})
        })
    }

    async initializeDataModel(name, description, modelType, protectedModel) {
        this.setState({loading: true})

        await API.patch(
            'data-models/' + this.state.editingDataModelID + '/change-name',
            {name},
            2
        )
        await API.patch(
            'data-models/' + this.state.editingDataModelID + '/change-type',
            {modelType},
            2
        )
        await API.patch(
            'data-models/' +
                this.state.editingDataModelID +
                '/change-description',
            {description},
            2
        )
        await API.patch(
            'data-models/' +
                this.state.editingDataModelID +
                '/change-model-protection',
            {protectedModel},
            2
        )

        if (modelType === 'State') {
            await API.patch(
                'data-models/' + this.state.editingDataModelID + '/add-field',
                {
                    name: 'Start_Time',
                    description: '(auto-generated) Start of state',
                    type: 'DesignatedTimeStart',
                    foreignDataModelId: null,
                    foreignAliasPath: null,
                    parentFieldId: null,
                    unique: false,
                    required: true,
                    protectedField: protectedModel,
                },
                2
            )
            await API.patch(
                'data-models/' + this.state.editingDataModelID + '/add-field',
                {
                    name: 'End_Time',
                    description: '(auto-generated) End of state',
                    type: 'DesignatedTimeEnd',
                    foreignDataModelId: null,
                    foreignAliasPath: null,
                    parentFieldId: null,
                    unique: false,
                    required: true,
                    protectedField: protectedModel,
                },
                2
            )
        }
        if (modelType === 'Event') {
            await API.patch(
                'data-models/' + this.state.editingDataModelID + '/add-field',
                {
                    name: 'Timestamp',
                    description: '(auto-generated) Timestamp',
                    type: 'DesignatedTimestamp',
                    foreignDataModelId: null,
                    foreignAliasPath: null,
                    parentFieldId: null,
                    unique: false,
                    required: true,
                    protectedField: protectedModel,
                },
                2
            )
        }

        await this.syncDataModels()

        this.setState({
            editingDataModelIsNew: false,
            loading: false,
        })
    }

    async editDataModelDetails(
        name,
        description,
        classic = false,
        collection = 'datamodeldata',
        query = '{}'
    ) {
        this.setState({loading: true})

        await API.patch(
            'data-models/' + this.state.editingDataModelID + '/change-name',
            {name},
            2
        )
        await API.patch(
            'data-models/' +
                this.state.editingDataModelID +
                '/change-description',
            {description},
            2
        )
        await API.patch(
            'data-models/' +
                this.state.editingDataModelID +
                '/change-data-model-classic-mode',
            {value: classic},
            2
        )
        await API.patch(
            'data-models/' +
                this.state.editingDataModelID +
                '/change-data-model-collection',
            {value: collection},
            2
        )
        await API.patch(
            'data-models/' +
                this.state.editingDataModelID +
                '/change-data-model-query',
            {value: query},
            2
        )

        await this.syncDataModels()

        this.setState({
            editingDataModelIsNew: false,
            loading: false,
        })
    }

    async updateDataModel(dataModelId, updates) {
        this.setState({loading: true})
        let {dataModels} = this.state
        let index = dataModels.findIndex((m) => m.id === dataModelId)
        for (let key in updates) {
            dataModels[index][key] = updates[key]
        }
        await dataModels[index].sync()

        this.setState({dataModels, loading: false})
    }

    async handleAddColumn({
        editingDataModelId,
        name,
        description,
        type,
        fidDataModelId,
        fidAliasPath,
        foreignOptionFilter,
        parentFieldId,
        pickListValues,
        unique,
        required,
        protectedField,
        kanbanField,
    }) {
        this.setState({loading: true})
        let dataModel = null
        const modifiedDataModel = await API.patch(
            'data-models/' +
                (editingDataModelId || this.state.editingDataModelID) +
                '/add-field',
            {
                name,
                description,
                type,
                foreignDataModelId: fidDataModelId,
                foreignAliasPath: fidAliasPath,
                foreignOptionFilter,
                parentFieldId,
                pickListValues,
                unique,
                required,
                protectedField,
            },
            2
        )

        await this.syncDataModels()
        dataModel = this.state.dataModels.find(
            (m) => m._id === this.state.editingDataModelID
        )

        if (kanbanField) {
            const kanbanModel = this.state.dataModels.find(
                (model) => model.name === 'System/Kanban Settings'
            )
            // check for existing entry
            let existing = await API.post(
                `data-models/${kanbanModel._id}/paginate`,
                {
                    filter: [
                        {
                            path: 'model_id',
                            type: 'Text',
                            value: [dataModel._id],
                            logic: 'is',
                        },
                    ],
                    limit: 1,
                },
                2
            )
            if (existing.count > 0) {
                let updated = existing.result.results[0]
                updated.status_field_path = name
                await API.patch(
                    `data-models/${kanbanModel._id}/edit-record`,
                    updated,
                    2
                )
            } else {
                await API.post(
                    `data-models/${kanbanModel._id}/add-record`,
                    {
                        model_id: dataModel._id,
                        status_field_path: name,
                    },
                    2
                )
            }
        }

        const index = this.state.dataModels.findIndex(
            (d) => d._id === this.state.editingDataModelID
        )
        let dataModels = this.state.dataModels
        dataModels[index] = dataModel
        this.setState({
            dataModels,
            editingDataModel: dataModel,
            loading: false,
        })

        return modifiedDataModel
    }

    async handleArchiveColumn({fieldId, dataModelId}) {
        this.setState({loading: true})

        let dataModel = null

        await API.patch(
            'data-models/' + dataModelId + '/archive-field',
            {fieldId},
            2
        )

        await this.syncDataModels()
        dataModel = this.state.dataModels.find(
            (m) => m._id === this.state.editingDataModelID
        )

        const childDataModel = this.state.dataModels.find(
            (m) =>
                m.parentDataModelId === dataModelId &&
                m.parentFieldId === fieldId
        )
        if (childDataModel) {
            await API.patch(
                'data-models/' + childDataModel._id + '/archive',
                {},
                2
            )
        }

        const index = this.state.dataModels.findIndex(
            (d) => d._id === this.state.editingDataModelID
        )
        let dataModels = this.state.dataModels
        dataModels[index] = dataModel
        this.setState({
            dataModels,
            editingDataModel: dataModel,
            loading: false,
        })
    }

    async handleUpdateFieldDetails({
        fieldId,
        name,
        description,
        dataModelId,
        unique,
        required,
        pickListValues,
        kanbanField,
        foreignOptionFilter,
    }) {
        this.setState({loading: true})

        await API.patch(
            'data-models/' +
                (dataModelId || this.state.editingDataModelID) +
                '/change-field-name',
            {fieldId, name},
            2
        )
        await API.patch(
            'data-models/' +
                (dataModelId || this.state.editingDataModelID) +
                '/change-field-description',
            {fieldId, description},
            2
        )
        await API.patch(
            'data-models/' +
                (dataModelId || this.state.editingDataModelID) +
                '/change-field-requirement',
            {fieldId, required},
            2
        )
        await API.patch(
            'data-models/' +
                (dataModelId || this.state.editingDataModelID) +
                '/change-field-uniqueness',
            {fieldId, unique},
            2
        )
        await API.patch(
            'data-models/' +
                (dataModelId || this.state.editingDataModelID) +
                '/change-field-picklistvalues',
            {fieldId, pickListValues},
            2
        )
        await API.patch(
            'data-models/' +
                (dataModelId || this.state.editingDataModelID) +
                '/change-field-foreignoptionfilter',
            {fieldId, foreignOptionFilter},
            2
        )

        let dataModel = null

        await this.syncDataModels()
        dataModel = this.state.dataModels.find(
            (m) => m._id === this.state.editingDataModelID
        )

        const kanbanModel = this.state.dataModels.find(
            (model) => model.name === 'System/Kanban Settings'
        )
        // check for existing entry
        let existingKanbanField = await API.post(
            `data-models/${kanbanModel._id}/paginate`,
            {
                filter: [
                    {
                        path: 'model_id',
                        type: 'Text',
                        value: [dataModel._id],
                        logic: 'is',
                    },
                ],
                limit: 1,
            },
            2
        )

        if (
            existingKanbanField.count === 1 &&
            !kanbanField &&
            existingKanbanField.result.results[0].status_field_path === name
        ) {
            // no longer kanban field
            await API.remove(
                `data-models/${kanbanModel._id}/delete-record/${existingKanbanField.result.results[0]._id}`,
                2
            )
        } else if (kanbanField) {
            // becoming kanban field
            if (existingKanbanField.count > 0) {
                let updated = existingKanbanField.result.results[0]
                updated.status_field_path = name
                await API.patch(
                    `data-models/${kanbanModel._id}/edit-record`,
                    updated,
                    2
                )
            } else {
                await API.post(
                    `data-models/${kanbanModel._id}/add-record`,
                    {
                        model_id: dataModel._id,
                        status_field_path: name,
                    },
                    2
                )
            }
        }

        const index = this.state.dataModels.findIndex(
            (d) => d._id === this.state.editingDataModelID
        )
        let dataModels = this.state.dataModels
        dataModels[index] = dataModel
        this.setState({
            dataModels,
            editingDataModel: dataModel,
            loading: false,
        })
    }

    async handleArchiveDataModel() {
        this.setState({loading: true})
        let {dataModels} = this.state

        const dataModel = await API.patch(
            'data-models/' + this.state.editingDataModelID + '/archive',
            {},
            2
        )

        const index = this.state.dataModels.findIndex(
            (d) => d._id === this.state.editingDataModelID
        )
        dataModels[index] = dataModel
        this.setState({
            dataModels,
            editingDataModel: dataModel,
            loading: false,
        })
    }

    async addReference(referenceRecord) {
        this.setState({loading: true})
        let {dataModels} = this.state

        const dataModel = await API.post(
            'data-models/' + this.state.editingDataModelID + '/reference',
            referenceRecord,
            2
        )

        const index = this.state.dataModels.findIndex(
            (d) => d._id === this.state.editingDataModelID
        )
        dataModels[index] = dataModel
        this.setState({
            dataModels,
            editingDataModel: dataModel,
            loading: false,
        })
    }

    async deleteReference(referenceId) {
        this.setState({loading: true})
        let {dataModels} = this.state

        const dataModel = await API.remove(
            'data-models/' +
                this.state.editingDataModelID +
                '/reference/' +
                referenceId,
            2
        )

        const index = this.state.dataModels.findIndex(
            (d) => d._id === this.state.editingDataModelID
        )
        dataModels[index] = dataModel
        this.setState({
            dataModels,
            editingDataModel: dataModel,
            loading: false,
        })
    }

    componentWillMount() {
        this.syncDataModels()
    }

    render() {
        const height = document.documentElement.offsetHeight * 0.75
        return (
            <Fragment>
                <Row>
                    <Col className="text-right">
                        <Button
                            color="default"
                            onClick={() =>
                                this.setState({showImportModelModal: true})
                            }>
                            Import Model(s)
                        </Button>
                        <Button color="primary" onClick={this.addDataModel}>
                            Add Data Model
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col xs="4" style={{height}}>
                        <Sidebar
                            height={height}
                            dataModels={this.state.dataModels.filter(
                                (m) =>
                                    m.parentDataModelId === null &&
                                    m.parentFieldId === null
                            )}
                            onDataModelChange={this.handleDataModelChange}
                            editingDataModelID={this.state.editingDataModelID}
                        />
                    </Col>
                    <Col xs="8" style={{height}}>
                        {this.state.editingDataModelID ? (
                            <Editor
                                height={height}
                                editingDataModel={this.state.dataModels.find(
                                    (model) =>
                                        model._id ===
                                        this.state.editingDataModelID
                                )}
                                editingDataModelIsNew={
                                    this.state.editingDataModelIsNew
                                }
                                dataModels={this.state.dataModels}
                                initializeDataModel={this.initializeDataModel}
                                editDataModelDetails={this.editDataModelDetails}
                                updateDataModel={this.updateDataModel}
                                handleAddColumn={this.handleAddColumn}
                                handleArchiveColumn={this.handleArchiveColumn}
                                handleArchiveDataModel={
                                    this.handleArchiveDataModel
                                }
                                handleUpdateFieldDetails={
                                    this.handleUpdateFieldDetails
                                }
                                syncDataModels={this.syncDataModels}
                                addReference={this.addReference}
                                deleteReference={this.deleteReference}
                                kanbanFieldPath={this.state.kanbanFieldPath}
                            />
                        ) : null}
                    </Col>
                </Row>

                {this.state.showImportModelModal ? (
                    <ModelImporter
                        toggle={() =>
                            this.setState({showImportModelModal: false})
                        }
                        dataModels={this.state.dataModels}
                        syncDataModels={this.syncDataModels}
                    />
                ) : null}
                {this.state.loading ? <div className="loading" /> : null}
            </Fragment>
        )
    }
}
